<template>
  <div
    id="features"
    class="mx-auto flex max-w-7xl flex-col gap-12 px-4 py-16 sm:px-6 lg:px-8"
  >
    <div class="mx-auto flex w-full flex-col gap-y-8">
      <div class="mx-auto flex w-full max-w-[800px] flex-col items-center justify-center gap-2 text-center">
        <h1 class="text-pretty text-3xl font-medium tracking-[-0.4px] text-gray-950 sm:text-4xl sm:tracking-[-0.72px] lg:text-balance">
          Unleash creativity with powerful features
        </h1>
        <p class="text-pretty text-lg text-gray-800 sm:text-xl sm:leading-[30px]">
          Creating stunning postcards should be a joy, not a headache. We understand the importance of simplicity when it comes to design tools.
        </p>
      </div>

      <div class="flex w-full items-center justify-center">
        <Tabs
          default-value="tools"
          class="flex w-full flex-col gap-y-10"
        >
          <TabsList
            class="w-full justify-start gap-2 overflow-auto rounded-[10px] border border-gray-300 bg-gradient-to-b from-[rgba(249,250,251,0.8)] to-[rgba(242,244,247,0.8)] p-1.5 shadow-[0px_1px_0px_0px_rgba(16,24,40,0.1)] sm:mx-auto sm:w-auto sm:justify-center"
          >
            <TabsTrigger
              v-for="(tab, index) in tabs"
              :key="index"
              :value="tab.value"
              class="rounded-lg px-3 py-2 text-sm font-medium text-gray-800 data-[state=active]:bg-gradient-to-b data-[state=active]:from-primary-600 data-[state=active]:to-primary-700 data-[state=active]:font-semibold data-[state=active]:text-primary-50 data-[state=active]:shadow-[inset_0px_-1px_0px_0px_rgba(16,24,40,0.2)]"
            >
              {{ tab.label }}
            </TabsTrigger>
          </TabsList>
          <TabsContent
            v-for="(tab, index) in tabs"
            :key="index"
            :value="tab.value"
            class="w-full lg:min-w-[592px]"
          >
            <component
              :is="tab.component"
              class="w-full"
            />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/Components/ui/tabs";
import ToolsTab from "./TabbedBentoTabs/ToolsTab.vue";
import VariableDataTab from "./TabbedBentoTabs/VariableDataTab.vue";
import PowerfulAddOnsTab from "./TabbedBentoTabs/PowerfulAddOnsTab.vue";
import TemplatesTab from "./TabbedBentoTabs/TemplatesTab.vue";

const tabs = shallowRef([
  {
    label: "Easy to use tools",
    value: "tools",
    component: ToolsTab,
  },
  {
    label: "Variable Data & Preview",
    value: "data",
    component: VariableDataTab,
  },
  {
    label: "Powerful add-ons",
    value: "addOns",
    component: PowerfulAddOnsTab,
  },
  {
    label: "Templates",
    value: "templates",
    component: TemplatesTab,
  },
]);
</script>
